module.exports = __webpack_public_path__ + "static/media/pt.9832b4dd.svg";